// "Live updates are down, this list may be out of date" for a list pane. Always mounted at the foot of
// the pane and pinned to its bottom edge (styles/refresh.css), so it appears and goes without moving
// anything above it. Empty, it is an idle live region.
import type { StreamStatus } from '../lib/events.ts';

/** The event stream is down, so data on screen may be stale. A catch-up after a reconnect is not: the
 * masthead's refresh bar shows that. */
export function streamIsDown(stream: StreamStatus | null | undefined): boolean {
  if (!stream) return false;
  return stream.state !== 'live' && stream.state !== 'idle' && stream.state !== 'connecting' && stream.state !== 'resyncing';
}

export function StaleNote({ text }: { text: string | null }) {
  return <p className="stale-note" role="status">{text}</p>;
}
